<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>兑换码</div>
		<div class="title">
			<div class="left">
				<router-link to="/newExchangecode"><el-button type="primary"
						size="small">新建兑换码</el-button></router-link>
			</div>
			<div class="right">
				<span>有效时间</span>
				<el-date-picker size="small" style="width:300px;margin:0 20px;" v-model="filter.time"
					type="datetimerange" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
				<el-select v-model="filter.status" style="width: 100px;margin-right: 20px;" size="small">
					<el-option v-for="item in activeStateList" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
				<el-input type="text" v-model="filter.name" style="width: 200px;margin-right: 20px;"
					size="small"></el-input>
				<el-button type="primary" size="small" @click="filter.pageNum=1; getCodePlans();">筛选</el-button>
			</div>
		</div>
		<div class="tabelContent" style="margin-top: 20px;">
			<el-table :data="exchangeCodeList" :header-cell-style="{background:'#F2F2F4','text-align':'center'}"
				style="width: 100%">
				<el-table-column prop="name" align="center" label="兑换码名称"></el-table-column>
				<el-table-column label="兑换内容" prop="title" align="center" width="200"></el-table-column>
				<el-table-column prop="startTime" align="center" label="生效日期"></el-table-column>
				<el-table-column prop="endTime" align="center" label="失效日期"></el-table-column>
				<el-table-column align="center" width="100" label="使用数/总数">
					<template slot-scope="scope">
						<span>{{scope.row.getNum}}/{{scope.row.total}}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" width="80" label="状态">
					<template slot-scope="scope">
						<span>{{ scope.row.status | statusFormat }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="250">
					<template slot-scope="scope">
						<el-button type="text" @click="downCode(scope.row.id)">下载</el-button>
						<el-button type="text"
							@click="$router.push({path:'/exhistory', query: scope.row})">使用记录</el-button>
						<el-button type="text" v-if="scope.row.status<=1"
							@click="invalid(scope.row.id)">立即失效</el-button>
						<el-button type="text" v-else style="color: red;">已失效</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background @current-change="codePlanPage" @size-change="handleSizeChange"
				style="margin-top: 30px;" layout="sizes, prev, pager, next" :current-page="filter.pageNum"
				:page-size="filter.pageSize" :total="filter.total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import {
		url
	} from "../../../utils/index.js"
	export default {
		data() {
			return {
				url: url(),
				activeStateList: [{
					label: "全部状态",
					value: -1,
				}, {
					label: "未开始",
					value: 0,
				}, {
					label: "进行中",
					value: 1,
				}, {
					label: "已结束",
					value: 2,
				}, {
					label: "已失效",
					value: 3,
				}, ],
				exchangeCodeList: [],
				deleteAd: false,
				filter: {
					name: undefined,
					status: -1,
					time: undefined,
					startTime: undefined,
					endTime: undefined,
					pageNum: 1,
					pageSize: 10,
					total: 0,
				},
			}
		},
		mounted() {
			this.getCodePlans();
		},
		filters: {
			statusFormat(val) {
				switch (val) {
					case 0:
						return "未开始";
					case 1:
						return "进行中";
					case 2:
						return "已结束";
					case 3:
						return "已失效";
				}
			}
		},
		methods: {
			downCode(id) {
				let urls = "id=" + id
				window.location.assign(this.url + "codePlan/downCode?" + urls);
			},
			invalid(id) {
				this.$http.post("codePlan/invalid/" + id).then(res => {
					if (res.body.code == 200) {
						this.getCodePlans();
					} else {
						this.$, message.error(res.body.msg);
					}
				})
			},
			codePlanPage(val) {
				this.filter.pageNum = val;
				this.getCodePlans();
			},
			getCodePlans() {
				if (this.filter.time) {
					this.filter.startTime = this.filter.time[0];
					this.filter.endTime = this.filter.time[1];
				} else {
					this.filter.startTime = this.filter.endTime = undefined;
				}
				this.$http.post("codePlan/list", JSON.stringify(this.filter)).then(res => {
					this.exchangeCodeList = res.body.data;
					this.filter.total = res.body.total;
				})
			},
			handleSizeChange(val) {
				this.filter.pageSize = val;
				this.getCodePlans();
			}
		}
	}
</script>

<style lang="less" scoped>
	p {
		padding: 0;
		margin: 0;
	}

	.title {
		width: 100%;

		.left {
			float: left;
		}

		.right {
			float: right;
		}

		&::after {
			content: "";
			width: 1px;
			display: block;
			clear: both;
		}
	}
</style>